import type { FC, ReactNode } from 'react';
import Stack from '@mui/material/Stack';

import { SideNavItem } from './side-nav-item';
import { Divider, Typography } from '@mui/material';

interface Item {
  disabled?: boolean;
  external?: boolean;
  icon?: ReactNode;
  items?: Item[];
  label?: ReactNode;
  path?: string;
  title: string;
}

const renderItems = ({
  depth = 0,
  items,
  pathname,
  isSideNav,
  setIsSideNav,
}: {
  depth?: number;
  items: Item[];
  pathname?: string | null;
  isSideNav: boolean;
  setIsSideNav: any;
}): JSX.Element[] =>
  items.reduce(
    (acc: JSX.Element[], item) =>
      reduceChildRoutes({
        acc,
        depth,
        isSideNav,
        item,
        pathname,
        setIsSideNav,
      }),
    []
  );

const reduceChildRoutes = ({
  acc,
  depth,
  item,
  pathname,
  isSideNav,
  setIsSideNav,
}: {
  acc: JSX.Element[];
  depth: number;
  item: Item;
  isSideNav: boolean;
  pathname?: string | null;
  setIsSideNav: any;
}): Array<JSX.Element> => {
  const checkPath = !!(item.path && pathname);
  const partialMatch = checkPath ? pathname.includes(item.path!) : false;
  const exactMatch = checkPath ? pathname === item.path : false;

  if (item.items) {
    acc.push(
      <SideNavItem
        active={partialMatch}
        depth={depth}
        disabled={item.disabled}
        icon={item.icon}
        key={item.title}
        label={item.label}
        open={partialMatch}
        isSideNav={isSideNav}
        setIsSideNav={setIsSideNav}
        title={item.title}
      >
        <Stack
          component="ul"
          spacing={0.5}
          sx={{
            listStyle: 'none',
            m: 0,
            p: 0,
          }}
        >
          {renderItems({
            depth: depth + 1,
            items: item.items,
            pathname,
            isSideNav,
            setIsSideNav,
          })}
        </Stack>
      </SideNavItem>
    );
  } else {
    acc.push(
      <SideNavItem
        active={partialMatch}
        depth={depth}
        disabled={item.disabled}
        external={item.external}
        icon={item.icon}
        isSideNav={isSideNav}
        setIsSideNav={setIsSideNav}
        key={item.title}
        label={item.label}
        path={item.path}
        title={item.title}
      />
    );
  }

  return acc;
};

interface SideNavSectionProps {
  items?: Item[];
  pathname?: string | null;
  subheader?: string;
  isSideNav: boolean;
  setIsSideNav: any;
}

export const SideNavSection: FC<SideNavSectionProps> = (props) => {
  const { items = [], pathname, isSideNav, subheader = '', setIsSideNav, ...other } = props;

  return (
    <Stack
      component="ul"
      spacing={0.5}
      sx={{
        listStyle: 'none',
        m: 0,
        p: 0,
      }}
      {...other}
    >
      {subheader && isSideNav && (
        <Typography
          component="li"
          // sx={{
          //   color: 'var(--nav-section-title-color)',
          //   fontSize: 12,
          //   fontWeight: 700,
          //   lineHeight: 1.66,
          //   mb: 1,
          //   ml: 1,
          //   textTransform: 'uppercase',
          // }}
          sx={{ color: '#B5BCC4' }}
          variant="overline"
        >
          {subheader}
        </Typography>
      )}
      {!isSideNav && <Divider sx={{ borderColor: '#E5E7EB', marginBottom: '.5rem' }} />}
      {renderItems({ items, pathname, isSideNav, setIsSideNav })}
    </Stack>
  );
};
